import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const PRIMARY = "#B4533A";
const SAFFRON = "#E8A33D";
const TEAL = "#2C5F5C";
const INDIGO = "#2E3A87";
const INK = "#1A1A1A";
const COLOR_CYCLE = [PRIMARY, SAFFRON, TEAL, INDIGO];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-ink/20 px-3 py-2 font-mono text-xs">
      <div className="text-ink-mute">{label}</div>
      <div className="text-ink font-medium mt-0.5">{payload[0].value} citations</div>
    </div>
  );
};

export const CitationsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div
        className="editorial-card p-10 text-center text-ink-mute font-mono text-sm"
        data-testid="citations-chart-empty"
      >
        No yearly citation data available yet.
      </div>
    );
  }
  const max = Math.max(...data.map((d) => d.count));
  return (
    <div className="editorial-card p-6 lg:p-8" data-testid="citations-chart">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-2">
        <div>
          <div className="overline">Annual citations</div>
          <p className="font-display text-2xl tracking-tight mt-1">
            Peak year reached <span className="text-terracotta">{max}</span> citations
          </p>
        </div>
        <div className="font-mono text-xs text-ink-mute">
          {data[0].year} — {data[data.length - 1].year}
        </div>
      </div>
      <div className="h-64 sm:h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 8, left: -8, bottom: 0 }}>
            <CartesianGrid stroke="#E5E5E0" strokeDasharray="2 4" vertical={false} />
            <XAxis
              dataKey="year"
              stroke={INK}
              tick={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 11, fill: "#666" }}
              tickLine={false}
              axisLine={{ stroke: "#E5E5E0" }}
            />
            <YAxis
              stroke={INK}
              tick={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 11, fill: "#666" }}
              tickLine={false}
              axisLine={false}
              width={32}
            />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(180, 83, 58, 0.06)" }} />
            <Bar dataKey="count" radius={[2, 2, 0, 0]}>
              {data.map((entry, idx) => (
                <Cell
                  key={entry.year}
                  fill={
                    entry.count === max
                      ? PRIMARY
                      : COLOR_CYCLE[idx % COLOR_CYCLE.length]
                  }
                  fillOpacity={entry.count === max ? 1 : 0.78}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CitationsChart;
